import React from "react";
import { Outlet } from "react-router-dom";
const ServiceRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default ServiceRoot;
